// A3 qo'shimcha ekranlari uchun ULASHILGAN UI bo'laklari (ekran EMAS — helper).
// Har bir per-user amal ekrani bir xil ko'rinsin: «Karta»ga qaytish, sabab
// maydoni, karta o'ramи. Takrorlanishни kamaytiradi.
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'
import { USERS_STR as S } from './usersAdminApi'

/** PageHeader `actions=` uchun «Karta»ga qaytish havolasi (per-user ekranlar). */
export function CardBackLink({ id }: { id: string | number }) {
  return (
    <Link
      to={`/users/${id}`}
      className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
    >
      <ChevronLeft size={13} />
      {S.back}
    </Link>
  )
}

/** PageHeader `actions=` uchun ro'yxatga qaytish havolasi (list-darajali ekranlar). */
export function ListBackLink() {
  return (
    <Link
      to="/users"
      className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
    >
      <ChevronLeft size={13} />
      {S.toList}
    </Link>
  )
}

/** Markazlangan, aylanadigan tana (barcha per-user ekranlar bitta o'lchamда). */
export function Body({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-0 flex-1 overflow-auto p-3">
      <div className="mx-auto max-w-2xl space-y-3">{children}</div>
    </div>
  )
}

/** Sarlavha + izohli karta o'rami. */
export function ActionCard({
  title,
  hint,
  children,
}: {
  title?: string
  hint?: string
  children: ReactNode
}) {
  return (
    <div className="rounded-lg border border-border-default bg-surface-2 p-4">
      {title ? <div className="text-sm font-medium text-secondary">{title}</div> : null}
      {hint ? <p className="mt-1 text-xs text-tertiary">{hint}</p> : null}
      <div className="mt-3 space-y-3">{children}</div>
    </div>
  )
}

/** Sabab (majburiy) maydoni — auditga tushadi. */
export function ReasonInput({
  value,
  onChange,
  rows = 2,
}: {
  value: string
  onChange: (v: string) => void
  rows?: number
}) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs text-tertiary">{S.reason}</span>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={S.reasonPh}
        rows={rows}
        maxLength={2000}
        className="w-full resize-y rounded-md border border-border-default bg-surface-1 px-3 py-2 text-sm text-primary outline-none focus:border-border-strong"
      />
    </label>
  )
}
